'use strict';

angular.module('far.educations')
    .controller('EducationReportController', function ($window, $log, $scope, $http, $uibModal, education, educationReport, educationReportForm, FileUploader) {
        var ascentRouteItems = {};

        var vm = {
            progress: true,
            initEventReport: initEventReport,
            reportForm: educationReportForm,
            event: {},
            submit: submit,
            sendReport: sendReport,
            accepted: accepted,
            getDocumentUrl: getDocumentUrl,
            mountainFormAdd: mountainFormAdd
        };

        vm.reportForm.$fields.club.uiSelectOptions.onSelect = function (item) {
            vm.event.event_education.club = item ? item : null;
        };

        vm.reportForm.$fields.userChief.uiSelectOptions.onSelect = function (item, model, options) {
            vm.event.event_education.users.forEach(function (user, index) {
                if (user.uniqId === options.index) {
                    vm.event.event_education.users[index].user = model;
                }
            });
        };
        vm.reportForm.$fields.userCoach.uiSelectOptions.onSelect = function (item, model, options) {
            vm.event.event_education.users.forEach(function (user, index) {
                if (user.uniqId === options.index) {
                    vm.event.event_education.users[index].user = model;
                }
            });
        };
        vm.reportForm.$fields.userSafety.uiSelectOptions.onSelect = function (item, model, options) {
            vm.event.event_education.users.forEach(function (user, index) {
                if (user.uniqId === options.index) {
                    vm.event.event_education.users[index].user = model;
                }
            });
        };

        vm.reportForm.$fields.countUsersTotal.options.class = 'form__item width-50';
        vm.reportForm.$fields.userInstructor.uiSelectOptions.onSelect = function (item, model, options) {
            vm.reportModel.updateUser(options.index, item);
        };
        vm.reportForm.$fields.userJuniorInstructor.uiSelectOptions.onSelect = function (item, model, options) {
            vm.reportModel.updateUser(options.index, item);
        };
        vm.reportForm.$fields.ascents.childForm.$fields.ascent_mountain_peak.uiSelectOptions.onSelect = function (item, model, options) {
            if (item && (angular.isUndefined(vm.reportModel.ascents[options.index].ascent_mountain_peak) || item.id != vm.reportModel.ascents[options.index].ascent_mountain_peak.id)) {
                vm.reportModel.ascents[options.index].ascent_mountain_peak = item;
                refreshMountainRouteAutoComplete(options.index);
            }
        };
        vm.reportForm.$fields.ascents.mountainFormAdd = mountainFormAdd;
        vm.reportForm.$fields.ascents.childForm.$fields.ascent_mountain_route.ngOptions = 'item as item.name  + " / " + item.mountain_route_complexity.name for item in field.getRouteItems(fieldIndex) track by item.id';
        vm.reportForm.$fields.ascents.childForm.$fields.ascent_mountain_route.getRouteItems = getRouteItems;

        vm.reportForm.$fields.ascents.childForm.$fields.instructor.uiSelectOptions.onSelect = function (item, model, options) {
            if (item) {
                vm.reportModel.ascents[options.index].instructor = item;
            }
        };
        vm.reportForm.$fields.ascents.childForm.$fields.user_chief.uiSelectOptions.onSelect = function (item, model, options) {
            if (item) {
                vm.reportModel.ascents[options.index].user_chief = item;
            }
        };

        function mountainFormAdd(index) {
            var modalInstance = $uibModal.open({
                templateUrl: '/modals/mountain-route-form/mountain-route-form.html',
                controller: 'MountainRouteFormController as routeForm',
                windowClass: 'modal-route',
                resolve: {
                    selectedPeak: function () {
                        return vm.reportModel.ascents[index].ascent_mountain_peak;
                    }
                }
            });

            modalInstance.result.then(function (route) {
                vm.reportModel.ascents[index].ascent_mountain_route = route;
                vm.reportModel.ascents[index].ascent_mountain_peak = route.mountain_peaks[0];
                refreshMountainRouteAutoComplete(index);
            });
        }

        function getRouteItems(index) {
            if (angular.isUndefined(ascentRouteItems[index])) {
                ascentRouteItems[index] = [];
            }

            return ascentRouteItems[index];
        }

        function refreshMountainRouteAutoComplete(index) {
            $http.get(Routing.generate('api_entities_get_mountainroutes', {
                offset: 0,
                limit: 100,
                peak_id: vm.reportModel.ascents[index].ascent_mountain_peak.id
            })).then(function (response) {
                angular.isUndefined(ascentRouteItems[index]) ?
                    ascentRouteItems[index] = [] :
                    ascentRouteItems[index].length = 0;

                angular.forEach(response.data, function (route) {
                    ascentRouteItems[index].push(route[0]);
                });
            }).catch(function (response) {
                $log.error(response);
            });
        }

        function initEventReport(eventId, eventReportEdit) {
            if (eventReportEdit) {
                vm.event = education.get(eventId, vm.eventUserTypes, function () {
                    vm.reportModel = educationReport.get(eventId, vm.eventUserTypes, function (report) {
                        report.ascents.forEach(function (ascent, index) {
                            ascent.ascent_mountain_peak = ascent.ascent_mountain_route.mountain_peaks[0];
                            refreshMountainRouteAutoComplete(index);
                        });

                        if (vm.reportModel.documents_files.length > 0) {
                            vm.reportModel.documents_files.forEach(function (serverFile) {
                                var newFile = new FileUploader.FileItem(vm.reportForm.$fields.documentsFiles.uploader, {
                                    lastModifiedDate: new Date(),
                                    size: 1e6,
                                    name: serverFile.original_name
                                });

                                newFile.progress = 100;
                                newFile.isUploaded = true;
                                newFile.isSuccess = true;
                                newFile.serverData = angular.merge({}, serverFile);

                                vm.reportForm.$fields.documentsFiles.uploader.queue.push(newFile);
                            });
                        }

                        vm.progress = false;

                        if (vm.reportModel.users_complite) {
                            var users = [];

                            vm.reportModel.users_complite.forEach(function(user) {
                                if ('user' in user) {
                                    users.push({fio:user.user.fio, email: user.user.email})
                                }
                            });

                            vm.reportModel.users_complite = users;
                        }

                    });
                });
            } else {
                vm.event = education.get(eventId, vm.eventUserTypes, function () {
                    vm.progress = false;
                });

                vm.reportModel = educationReport.new({
                    event_id: eventId
                }, vm.eventUserTypes);
            }
        }

        function getDocumentUrl(file_id) {
            return Routing.generate('api_upload_get_file', {fileStorage: file_id});
        }

        function sendReport() {
            vm.reportModel.submitted = true;
            vm.reportModel.accepted = false;

            submit();
        }

        function accepted() {
            vm.reportModel.submitted = true;
            vm.reportModel.accepted = true;

            submit();
        }

        function submit() {
            console.log($scope.educationReportForm.$invalid);

            if (vm.progress || $scope.educationReportForm.$invalid) {
                return;
            }

            vm.progress = true;

            // FIXME
            vm.reportModel.ascent_user_types = vm.ascent_user_types;
            vm.reportModel.eventUserTypes = vm.eventUserTypes;

            vm.reportModel.event = {
                id: vm.event.id,
                description: vm.event.description,
                club: vm.event.event_education.club,
                users: vm.event.event_education.users
            };

            vm.reportModel.documents_files = vm.documents_files;

            //console.log(vm.reportModel.event);

            vm.reportModel.save()
               .then(function (response) {
                    //$log.debug('ok!');

                    $window.location.href = Routing.generate('event_view', {id: response.data.id});
               })
               .catch(function (response) {
                   $log.error(response);

                   vm.progress = false;
               });
        }

        window.educationReportController = vm;

        return vm;
    });
